interface BaseParsedLink {
  href: string;
  type: string;
}

export interface ParsedUrlLink extends BaseParsedLink {
  type: 'url';
}

export interface ParsedBookmarkLink extends BaseParsedLink {
  bookmark: string;
  type: 'bookmark';
}

export interface ParseLinkError extends BaseParsedLink {
  type: 'error';
}

export type ParsedLink = ParsedUrlLink | ParsedBookmarkLink | ParseLinkError;

const allowedSchemes = ['http:', 'https:', 'ftp:', 'mailto:', 'tel:'];
const errorResult: ParseLinkError = { href: 'about:blank', type: 'error' };

/**
 * Parse a link in the editor, determining whether it links to a URL or a bookmark, and whether it
 * is valid.
 */
export function parseLink(value: string): ParsedLink {
  const isBookmark = value.startsWith('#');
  const allowRelative = isBookmark || value.startsWith('//');

  let url: URL;
  try {
    const baseUrl = typeof window === 'undefined' ? 'https://aline.co/' : window.location.href;
    url = new URL(value, allowRelative ? baseUrl : undefined);
  } catch {
    return errorResult;
  }

  if (!allowedSchemes.includes(url.protocol)) {
    return errorResult;
  }

  const { href } = url;

  if (isBookmark) {
    return { bookmark: url.hash.replace(/^#/, ''), href, type: 'bookmark' };
  }

  return { href, type: 'url' };
}

/**
 * Validate a link in the editor.
 */
export function validateLink(value: string): boolean {
  return parseLink(value).type !== 'error';
}
